import './locales';
import { BrowserRouter } from 'react-router-dom';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import Layout from '@/components/layout';
import Canonical from './Canonical';
import ErrorBoundary from '@/components/template/ErrorBoundary';
import ScrollToTop from './ScrollToTop';
import store, { persistor } from './store';
import Theme from '@/components/template/Theme';
import Toaster from '@/components/template/Toaster';
import { MotionProvider } from '@/utils/motion';

function App() {
	return (<Provider store={store}>
		<PersistGate loading={null} persistor={persistor}>
			<BrowserRouter>
				<MotionProvider>
					<ScrollToTop />
					<Canonical />
					<Theme>
						<ErrorBoundary>
							<Layout />
						</ErrorBoundary>
					</Theme>
					<Toaster />
				</MotionProvider>
			</BrowserRouter >
		</PersistGate>
	</Provider>);
}

export default App;